<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconFullscreenOff_32"
    viewBox="0 0 32 32"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="m23.148 11.21 4.692 1.577a.858.858 0 0 1-.273 1.672H18.4a.858.858 0 0 1-.859-.859V4.433a.858.858 0 0 1 1.672-.273l1.578 4.692 4.764-4.764a1.666 1.666 0 1 1 2.357 2.357l-4.764 4.764ZM4.433 17.54H13.6c.475 0 .859.384.859.859v9.167a.858.858 0 0 1-1.672.273l-1.578-4.692-4.764 4.764a1.667 1.667 0 0 1-2.357-2.357l4.764-4.764-4.692-1.578a.858.858 0 0 1 .273-1.672Z"
        clip-rule="evenodd"
    />
</svg>
